function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#5E5E5E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24 27.9c0 .608-.46 1.1-1.029 1.1-.568 0-1.028-.492-1.028-1.1 0-5.191-3.584-7.7-9.943-7.7-6.36 0-9.943 2.509-9.943 7.7 0 .608-.46 1.1-1.028 1.1C.46 29 0 28.508 0 27.9 0 21.25 4.642 18 12 18s12 3.25 12 9.9zM12.5 17C8.715 17 6 12.66 6 8.146 6 3.778 8.678 0 12.5 0S19 3.778 19 8.146C19 12.66 16.285 17 12.5 17zm0-2.125c2.418 0 4.447-3.245 4.447-6.73 0-3.31-1.92-6.02-4.447-6.02s-4.447 2.71-4.447 6.02c0 3.485 2.03 6.73 4.447 6.73z",
  transform: "translate(-37 -658) translate(37 658)"
}))));

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bb02fd41.svg";
export { ForwardRef as ReactComponent };